var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-frame"},[_c('StageFrame'),_c('OverlayFrame',{ref:"overlay"}),_c('UIFrame')],1)}
var staticRenderFns = []

export { render, staticRenderFns }